<template>
    <div id="tableDiv" class="table-width">
        <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" removableSort
                   filterDisplay="row" stripedRows :rowsPerPageOptions="[10, 25, 50]" responsiveLayout="scroll"
                   :filters.sync="filters" class="p-datatable-striped"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :currentPageReportTemplate="$t('AppOperationsExportHistoryTable.currentPageReportTemplate')">
            <template #empty>
                {{ $t('AppOperationsExportHistoryTable.Sem dados para exibir') }}
            </template>
            <template #loading>
                {{ $t('AppOperationsExportHistoryTable.Carregando arquivos, por favor aguarde') }}
            </template>
            <Column field="file_name" :header="$t('AppOperationsExportHistoryTable.Arquivo')" headerClass="headerClass"
                    :styles="{'min-width':'15rem'}" bodyClass="bodyClass" sortable :showFilterMenu="false"
                    :showClearButton="false">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" @input="filterCallback()"/>
                </template>
            </Column>
            <Column field="field_information.field_name" :header="$t('AppOperationsExportHistoryTable.Talhão')"
                    headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width':'15rem'}" sortable
                    :showFilterMenu="false" :showClearButton="false">
                <template #filter="{filterModel,filterCallback}">
                    <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="fields" :dataKey="'id'"
                                 :placeholder="$t('AppOperationsExportHistoryTable.Selecione')" appendTo="tableDiv"
                                 class="p-column-filter width-multiselect" :showClear="true" optionLabel="name"
                                 optionValue="name" filter>
                        <template #value="slotProps">
                            <span v-for="val in slotProps.value" style="margin-right: 5px">
                                {{ val.name }}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <span>
                                {{ slotProps.option.name }}
                            </span>
                        </template>
                    </MultiSelect>
                </template>
            </Column>
            <Column field="status" :header="$t('AppOperationsExportHistoryTable.Status')" :styles="{'min-width':'9rem'}"
                    headerClass="headerClass" sortable :showFilterMenu="false" :showClearButton="false"
                    bodyClass="bodyClass">
                <template #body="slotProps">
                    <span :class="'badge export-status-' + slotProps.data.status" style="font-weight: bold">
                        {{ getStatus(slotProps.data.status) }}
                    </span>
                </template>
                <template #filter="{filterModel,filterCallback}">
                    <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="statusOptions"
                                 :placeholder="$t('AppOperationsExportHistoryTable.Selecione')" appendTo="tableDiv"
                                 class="p-column-filter width-multiselect" :showClear="true" optionLabel="name"
                                 optionValue="code">
                        <template #value="slotProps">
                            <span v-for="val in slotProps.value" :class="'badge export-status-' + val"
                                  style="margin-right: 5px">
                                {{ getStatus(val) }}
                            </span>
                        </template>
                        <template #option="slotProps">
                            <span :class="'badge export-status-' + slotProps.option.code">
                                {{ getStatus(slotProps.option.code) }}
                            </span>
                        </template>
                    </MultiSelect>
                </template>
            </Column>
            <Column field="formatted_created_date" :header="$t('AppOperationsExportHistoryTable.Data de criação')"
                    :styles="{'min-width':'15rem'}" sortable headerClass="headerClass" :showFilterMenu="false"
                    :showClearButton="false" bodyClass="bodyClass">
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                </template>
            </Column>
            <Column field="formatted_last_modified_date"
                    :header="$t('AppOperationsExportHistoryTable.Última modificação')"
                    :styles="{'min-width':'15rem'}" headerClass="headerClass" :showFilterMenu="false"
                    :showClearButton="false" bodyClass="bodyClass" sortable>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                </template>
            </Column>
            <Column :styles="{'max-width':'3rem'}" headerClass="headerClass" bodyClass="bodyClass">
                <template #body="slotProps">
                    <Button :disabled="slotProps.data.status !== 'PROCESSED'" icon="pi pi-download"
                            class="p-button-rounded m-1" @click="downloadFile(slotProps.data)"/>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>

import MultiSelect from "primevue/multiselect";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import Button from "primevue/button/Button";
import InputText from "primevue/inputtext";
import {FilterMatchMode} from "primevue/api";
import {EXPORT_FILE_STATUS_OPTIONS} from "@/components/views/agriculture/AppAgricultureOptions";

export default {
    data() {
        return {
            statusOptions: EXPORT_FILE_STATUS_OPTIONS(),
            filters: {
                'file_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'field_information.field_name': {value: null, matchMode: FilterMatchMode.IN},
                'status': {value: null, matchMode: FilterMatchMode.IN},
                'formatted_created_date': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'formatted_last_modified_date': {value: null, matchMode: FilterMatchMode.CONTAINS}
            }
        }
    },
    props: {
        gridData: {
            type: Array
        },
        fields: {
            type: Array
        },
        loading: {
            type: Boolean
        }
    },
    methods: {
        getStatus(code) {
            switch (code) {
                case 'PROCESSING':
                    return this.$t('AppOperationsExportHistoryTable.Processando');
                case 'PROCESSED':
                    return this.$t('AppOperationsExportHistoryTable.Processado');
                case 'ERROR':
                    return this.$t('AppOperationsExportHistoryTable.Erro');
                case 'IN_QUEUE':
                    return this.$t('AppOperationsExportHistoryTable.Na fila');
            }
        },
        downloadFile(exportRequest) {
            this.$emit('download', exportRequest)
        }
    },
    components: {InputText, Button, DataTable, Column, MultiSelect}
}
</script>

<style scoped lang="scss">
@import "../style";

@media (max-width: 1024px){
    .table-width{
        width: 100vw;
    }
}

@media (min-width: 1025px){
    .table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
